import "../styles/footer.css";

export default function Footer({ t, lang }) {
  const pl = lang === "pl";
  return (
    <footer className="footer footer-restored">
      <div className="footer-container">
        <div className="footer-column">
          <h3>Eastlog</h3>
          <p>{pl ? "Profesjonalne usługi transportowe i logistyczne. Obsługujemy transport krajowy oraz międzynarodowy. Transport widenable trailers" : "Professional transport and logistics services. We handle domestic and international transport. Widenable trailers transport"}</p>
        </div>
        <div className="footer-column">
          <h4>{pl ? "Nawigacja" : "Navigation"}</h4>
          <nav aria-label={pl ? "Nawigacja w stopce" : "Footer navigation"}>
            <ul>
              <li><a href="#services">{t.services}</a></li>
              <li><a href="#about">{t.about}</a></li>
              <li><a href="#contact">{t.contact}</a></li>
            </ul>
          </nav>
        </div>
        <div className="footer-column">
          <h4>{pl ? "Dane firmy" : "Company details"}</h4>
          <p>Eastlog Sp. z o.o.</p>
          <p>NIP: 716-281-41-62</p>
          <p>REGON: 061557560</p>
          <p>{t.address}: Księżnej Izabelli 8/1, 24-100 Puławy</p>
          <p>{t.email}: <a href="mailto:office@eastlog.com.pl">office@eastlog.com.pl</a></p>
          <p>{t.phone}: <a href="tel:+48818867824">+48 81 886 78 24</a></p>
        </div>
      </div>
      <div className="footer-bottom">© 2026 Eastlog. {pl ? "Wszelkie prawa zastrzeżone." : "All rights reserved."}</div>
    </footer>
  );
}